<template>
  <div class="modal-add-email">
    <SfModal :visible="isVisible" @close="closeModal">
      <transition name="fade" mode="out-in">
        <div class="form">
          <SfButton id="send-verification-code" @click="connectWithGoogle">
            Connect with google
          </SfButton>
          <SfButton id="verify-phone-number" @click="connectWithFacebook">
            Connect with Facebook
          </SfButton>
        </div>
      </transition>
    </SfModal>
  </div>
</template>

<script>
import SfModal from "@lib/components/molecules/SfModal/SfModal";
import { notifications } from "@lib/modules/cart/helpers";
import { mapGetters } from "vuex";
import firebase from "@lib/firebase";
import SfButton from "@lib/components/atoms/SfButton/SfButton";

export default {
  name: "ModalAuthentication",
  components: { SfModal, SfButton },
  data() {
    return {
      errorMessage: "",
    };
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      email: "user/email",
    }),
  },
  watch: {
    email: {
      immediate: true,
      handler: function (val) {
        if (val) {
          this.$emit("close", this.modalData.name);
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close", this.modalData.name);
    },
    connectWithGoogle() {
      const googleProvider = new firebase.auth.GoogleAuthProvider();
      const self = this;
      firebase
        .auth()
        .currentUser.linkWithPopup(googleProvider)
        .then(async (result) => {
          var credential = result.credential;
          var user = result.user;
          await self.$store.dispatch("user/onLogin", user);
          this.$emit("close", this.modalData.name);
        })
        .catch((error) => {
          console.error(error);
          if (error.code) {
            console.error(error.code);
          }
          this.errorMessage = "Could not connect to the provided account";
        });
    },
    connectWithFacebook() {
      const facebookProvider = new firebase.auth.FacebookAuthProvider();
      firebase
        .auth()
        .currentUser.linkWithPopup(facebookProvider)
        .then((result) => {
          var credential = result.credential;
          var user = result.user;
          this.$emit("close", this.modalData.name);
        })
        .catch((error) => {
          console.error(error);
          console.error("Error!");
          this.errorMessage = "Could not connect to the provided account";
        });
    },
    async loginSuccess(user) {
      this.$store.dispatch(
        "notification/spawnNotification",
        notifications.createNotification({
          type: "success",
          message: "Login Successful",
        })
      );
      this.$emit("close", this.modalData.name);
    },
  },
};
</script>

<style lang="scss">
#recaptcha-container {
  width: 100%;
  min-height: 60px;
  padding-bottom: 16px;

  .grecaptcha-badge {
    position: static !important;
    margin: 0 auto;
  }
}

.modal-authentication {
  .firebaseui-idp-button {
    max-width: 300px;
    padding: 16px 32px;
  }
}
</style>
